import FilterWrap from "components/htmlElements/FilterWrap";
import React from "react";
import Select from "react-select";
import CustomOption from "./customOption";
import DropdownIndicator from "./dropdownIndicator";
import "./statusSelect.scss";

type SelectReusableProps = {
  options: { label: string; value: number }[];
  onChange: (value: { label: string; value: number }) => void;
  label?: string;
  selectedOption: { label: string; value: number };
  // setSelectedOption: (option: { label: string; value: number }) => void;
};

const SelectReusable = ({
  options,
  onChange,
  label,
  selectedOption,
}: SelectReusableProps) => {
  const selectComponents = { DropdownIndicator, Option: CustomOption };

  return (
    <FilterWrap className="filterWrap">
      <div className="customDropdown">
        {label && (
          <label htmlFor={label} className="floating-label">
            {label}
          </label>
        )}
        <Select
          placeholder={options?.[0].label}
          value={selectedOption}
          options={options}
          isRtl
          isSearchable={false}
          closeMenuOnSelect
          components={selectComponents}
          className="selectControl singleSelect"
          classNamePrefix="select"
          onChange={onChange}
        />
      </div>
    </FilterWrap>
  );
};

export default SelectReusable;
